import KeyValuePair from '@/modules/core/support/KeyValuePair'
import moment from 'moment'
import User from '@/modules/user/model/User';

/**
 * Grupo de usuarios
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class UserGroup {
    public id = 0
    public name = ''
    public createdAt = new Date()
    public updatedAt = new Date()
    public userCount = 0
    public groupChildrenCout = 0

    /**
     * Atributos adicionales del grupo
     */
    public attributes: KeyValuePair = {}

    /**
     * Usuarios que serán insertados cuando el grupo sea creado
     */
    public newUsers: User[] = []

    /**
     * Grupo padre
     */
    public parent: UserGroup | null = null

    /**
     * Lista de grupos hijos
     */
    public children: UserGroup[] = []

    /**
     * Ruta de acceso al grupo en el arbol
     */
    public path = ''

    /**
     * Ruta codificada en base64 para compatiblidad con rutas
     */
    public get encodedPath () {
        return btoa(this.path)
    }

    /**
     * Indica si la entidad es nueva y aún no ha sido registrada en el
     * servidor
     */
    public get isNew (): boolean {
        return !this.id
    }

    public serialize () {
        return {
            name: this.name,
            users: this.newUsers.map(u => u.id),
            attributes: this.attributes,
            parent: this.parent ? this.parent.id : null,
            children: this.children.map(c => c.id),
        }
    }

    /**
     * Crea una entidad a partir de los datos serializados de la API
     *
     * @param data
     */
    public static deserialize (data: KeyValuePair): any {

        // Obtener el nº de grupos (hijos) que puede tener asignados a un grupo (padre), si no viene
        // explicitamente especificado del servicio API (data.group_children_count) se extrae
        // del array de hijos (data.children)
        const aChildren = data.children || []
        const groupChildrenCount = data.group_children_count || 0
        const childrenCount = (groupChildrenCount === 0) ? aChildren.length  : data.group_children_count

        return Object.assign(new this(), {
            id: data.id,
            name: data.name,
            parent: data.parent ? UserGroup.deserialize(data.parent) : null,
            children: (data.children || []).map((c: KeyValuePair) => UserGroup.deserialize(c)),
            createdAt: moment(data.created_at, 'DD-MM-YYYY HH:mm:ss'),
            updatedAt: moment(data.updated_at, 'DD-MM-YYYY HH:mm:ss'),
            userCount: data.user_count,
            attributes: data.attributes || {},
            path: data.path,
            groupChildrenCout : childrenCount,
        })
    }
}
